import React, { type FunctionComponent } from 'react'
import { useDomainMessages } from '../../../utils/domain/intl.ts'
import {
  Input,
  PropertyContainer,
  PropertyRow,
  PropertyTitle,
} from '../../shared-styled-components/SharedStyledComponents'
import {
  AttributeManagementNextStepTypeEnum,
  type PipelineStep,
} from '../../../types/attributeManagement.types.ts'

interface Props {
  step: PipelineStep
  onChange: (step: PipelineStep) => void
}

const MAX_NUM_OF_FORKS = 10
const MIN_NUMBER_OF_FORKS = 2

export const PipelineFormStepControlFork: FunctionComponent<Props> = ({ step, onChange }) => {
  const i18n = useDomainMessages({
    numberOfForks:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.pipelineForm.controlFork.numberOfForks',
  })
  return (
    <>
      <PropertyContainer>
        <PropertyRow>
          <PropertyTitle>{i18n.numberOfForks}</PropertyTitle>
          <Input
            type="number"
            value={step?.nextStepsRule?.possibleNextSteps?.length ?? ''}
            onChange={e => {
              const count = Math.min(
                MAX_NUM_OF_FORKS,
                Math.max(MIN_NUMBER_OF_FORKS, Number.parseInt(e?.target?.value ?? '0'))
              )

              // Preserve existing values when resizing arrays
              const existingNextPipelineSteps = step?.nextStepsRule?.nextPipelineSteps ?? []
              const existingPossibleNextSteps = step?.nextStepsRule?.possibleNextSteps ?? []

              const nextPipelineSteps = Array(count)
                .fill('')
                .map((_, index) => existingNextPipelineSteps[index] ?? '')

              const possibleNextSteps = Array(count)
                .fill('')
                .map((_, index) => existingPossibleNextSteps[index] ?? '')

              onChange({
                ...step,
                nextStepsRule: {
                  type: AttributeManagementNextStepTypeEnum.Fork,
                  nextPipelineSteps,
                  possibleNextSteps,
                },
              })
            }}
          />
        </PropertyRow>
      </PropertyContainer>
    </>
  )
}
